import React, { useEffect, useState } from 'react';
import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report197() {
  
    const [Borrow197data, setBorrow197data] = useState([]);

    /*  async function GetV197() {
          const response197 = await fetch("/api/BorrowReports/getV197")
          const Borrow197data = await response197.json()
          setBorrow197data(Borrow197data.dataenum);
          console.log(Borrow197data)
      }*/

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear()+ 543)

    async function GetV197() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV197", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow197data(data.dataenum)

    }

    const [Re197yeardata, setRe197yeardata] = React.useState([]);
    async function getR197year() {
        const res = await fetch("/api/BorrowReports/getyear197")
        const Re197yeardata = await res.json()
        setRe197yeardata(Re197yeardata.dataenum)
        console.log(Re197yeardata)
    }



    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ประจำเดือน', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วงเงินกู้ยืม', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนลูกจ้าง', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ขนาดสถานประกอบกิจการที่กู้ยืมเงิน', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ลูกจ้างได้รับการพัฒนาฝีมือแรงงาน', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ประเภทหลักสูตรการฝึกอบรบ', colSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, { text: 'รวม', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}],
    //     [{}, {}, {}, { text: 'ลูกจ้างต่ำกว่า100คน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ลูกจ้างมากกว่า100คน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รวม', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ฝึกอบรม', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ทดสอบ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รวม', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หลักสูตรเฉพาะ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หลักสูตรทั่วไป', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หลักสูตร', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวน', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Borrow197data.forEach(function (item) {
    //         var rowdata = [{ text: item.month + ' ' + thYearSelected, alignment: 'left' }, { text: (NumberWithCommas(item.amountApprove)), alignment: 'right' }, { text: item.totalEmployee, alignment: 'right' }, { text: item.comLessThan100, alignment: 'right' }, { text: item.comMoreThan100, alignment: 'right' }, { text: item.sumCompany, alignment: 'right' }, { text: item.employeeTrain, alignment: 'right' }, { text: item.employeeTest, alignment: 'right' }, { text: item.sumEmployee, alignment: 'right' }, { text: item.specificCouse, alignment: 'right' }, { text: item.specificEmployee, alignment: 'right' }, { text: item.normalCouse, alignment: 'right' }, { text: item.normalEmployee, alignment: 'right' }, { text: item.sumCourse, alignment: 'right' }, { text: item.sumPerson, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',

    //         content: [
    //             { text: 'สรุปข้อมูลสถานประกอบกิจะการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน', style: 'header', alignment: 'center', bold: true, fontSize: 20 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. ' + thYearSelected, style: 'header', bold: true, alignment: 'center', fontSize: 16 },
    //             [{
    //                 table: {
    //                     widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    //                     body: tablebody
    //                 },
    //             }]],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R197')
    // }


    useEffect(() => {
        GetV197()
        getR197year()
    }, [thYearSelected])

    let sum1 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.amountApprove
    }, 0);
    let sum2 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.totalEmployee
    }, 0);
    let sum3 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.comLessThan100
    }, 0);
    let sum4 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.comMoreThan100
    }, 0);
    let sum5 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.sumCompany
    }, 0);
    let sum6 = Borrow197data.reduce(function (prev, current) {
       return prev + +current.employeeTrain
    }, 0);
    let sum7 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.employeeTest
    }, 0);
    let sum8 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.sumEmployee
    }, 0);
    let sum9 = Borrow197data.reduce(function (prev, current) {
       return prev + +current.specificCouse
    }, 0);
    let sum10 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.specificEmployee
    }, 0);
    let sum11 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.normalCouse
    }, 0);
    let sum12 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.normalEmployee
    }, 0);
    let sum13 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.sumCourse
    }, 0);
    let sum14 = Borrow197data.reduce(function (prev, current) {
        return prev + +current.sumPerson
    }, 0);

    return (
        <Container>
            {/* <div style={{ display: 'flex', paddingBottom: '10px', justifyContent: 'center' }}>
                <h3 style={{ paddingTop: '2px' }} className='text-center'>
                    ประจำปีงบประมาณ พ.ศ.
                </h3>

                <Input
                    style={{ borderColor: "#FFFFFF", width: "10%", paddingTop: '0px', fontSize: '1.60rem' }}
                    id="thYear"
                    name="thYear"
                    type="select"
                    value={thYearSelected}
                    onChange={(e) => {
                        setThYearSelected(e.target.value)
                    }}
                >
                    {Re197yeardata.map((item, i) => (
                        <option value={item.yearTh}>
                            {item.yearTh}
                        </option>

                    ))}
                </Input>
            </div> */}
            <div className='d-flex justify-content-center align-items-center'>
                <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                <Input
                    // className='report-select-one-year'
                    className="rounded-pill input-color w-25 text-center"
                    id="thYear"
                    name="thYear"
                    type="select"
                    value={thYearSelected}
                    onChange={(e) => {
                        if(e.target.value !== "กรุณาเลือก"){
                            setThYearSelected(e.target.value)
                        } else {
                            return;
                        }
                        
                    }}
                >
                    <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                    {Re197yeardata?.map((item, i) => (
                        <option className='option-style' value={item.yearTh}>
                            {item.yearTh}
                        </option>

                    ))}
                    
                </Input>
            </div>

            <div>
                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV197?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR197?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV197?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR197?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>
                

                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="2">
                                    ประจำเดือน
                                </th>
                                <th rowSpan="2">
                                    วงเงินกู้ยืม(บาท)
                                </th>
                                <th rowSpan="2">
                                    จำนวนลูกจ้าง(คน)
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ขนาดสถานประกอบกิจการที่กู้ยืมเงิน (แห่ง)
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ลูกจ้างได้รับการพัฒนาฝีมือแรงงาน (คน)
                                </th>
                                <th colSpan="4" className=' text-center'>
                                    ประเภทหลักสูตรการฝึกอบรบ
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    รวม
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    ลูกจ้างต่ำกว่า100คน
                                </th>
                                <th className='text-center'>
                                    ลูกจ้างมากกว่า100คน
                                </th>
                                <th className='text-center'>
                                    รวม
                                </th>
                                <th className='text-center'>
                                    ฝึกอบรม
                                </th>
                                <th className='text-center'>
                                    ทดสอบ
                                </th>
                                <th className='text-center'>
                                    รวม
                                </th>
                                <th className='text-center'>
                                    หลักสูตรเฉพาะ
                                </th>
                                <th className='text-center'>
                                    จำนวน(คน)
                                </th>
                                <th className='text-center'>
                                    หลักสูตรทั่วไป
                                </th>
                                <th className='text-center'>
                                    จำนวน(คน)
                                </th>
                                <th className='text-center'>
                                    หลักสูตร
                                </th>
                                <th className='text-center'>
                                    จำนวน(คน)
                                </th>
                            </tr>
                        </thead>
                        <tbody> {Borrow197data.map((item, i) => (

                            <tr key={i}>
                                <th scope="row" className='text-start'>
                                    {item.month + ' ' + item.budgetYear}
                                </th>
                                <td className='text-end'>
                                    {NumberWithCommas(item.amountApprove)}
                                </td>
                                <td className='text-end'>
                                    {item.totalEmployee1}
                                </td>
                                <td className='text-end'>
                                    {item.comLessThan1001}
                                </td>
                                <td className='text-end'>
                                    {item.comMoreThan1001}
                                </td>
                                <td className='text-end'>
                                    {item.sumCompany1}
                                </td>
                                <td className='text-end'>
                                    {item.employeeTrain1}
                                </td>
                                <td className='text-end'>
                                    {item.employeeTest1}
                                </td>
                                <td className='text-end'>
                                    {item.sumEmployee1}
                                </td>
                                <td className='text-end'>
                                    {item.specificCouse1}
                                </td>
                                <td className='text-end'>
                                    {item.specificEmployee1}
                                </td>
                                <td className='text-end'>
                                    {item.normalCouse1}
                                </td>
                                <td className='text-end'>
                                    {item.normalEmployee1}
                                </td>
                                <td className='text-end'>
                                    {item.sumCourse1}
                                </td>
                                <td className='text-end'>
                                    {item.sumPerson1}
                                </td>

                            </tr>))}

                        </tbody>
                        <tfoot>
                            <tr>
                                <th scope="row">
                                    รวมทั้งสิ้น
                                </th>
                                <td className='text-end'>
                                    {NumberWithCommas(sum1)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum2)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum3)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum4)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum5)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum6)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum7)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum8)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum9)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum10)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum11)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum12)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum13)}
                                </td>
                                <td className='text-end'>
                                        {NumberWithCommas(sum14)}
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </div>


            </div>

        </Container>
    );


}
